var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"BG"},[_c('img',{staticClass:"BG__grid",attrs:{"src":(_vm.$baseUrl + "images/bg/grid.svg"),"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }